import angular from 'angular';
import constants from 'app/constants';
import {
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import controller from './report-instance-comment.controller';
import directive from './report-instance-comment.directive';

export default angular.module('app.components.reports.archivedReports.reportType.archivedReportInstanceComment', [
  alerts,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('archivedReportInstanceComment', directive)
  .controller('ArchivedReportInstanceCommentController', controller)
  .name;

console.log('app.components.reports.archivedReports.reportType.archivedReportInstanceComment created');
